import React from 'react';
import { stencilAlignment as tooltip } from 'pu-data/Tooltips';
import RadioDualComponent from './RadioDualComponent';

const StencilAlignment = (props) => {
  const name = 'alignment';
  const onChange = (e) => props.onChangeParameter(name, e.target.value);
  return (
    <RadioDualComponent
      name={name}
      label="Alignment"
      tooltip={props.tooltip}
      onChange={onChange}
      parameters={props.parameters}
      className={props.className}
      groupName={props.groupName}
      required={props.required}
      labelA="Offset"
      valueA="Offset"
      labelB="Center"
      valueB="Center"
      labelClassName="d-block"
      errorMessage={props.errorMessage}/>
  );
};

StencilAlignment.defaultProps = {
  tooltip,
  className: 'class-3-inspection',
};

export default StencilAlignment;
